import {
  GET_AFFILIATE_SETTING,
  SET_AFFILIATE_SETTING,
  POST_AFFILIATE_SETTING,
} from './action_types';

export default {
  setAffiliateSetting: (data) => ({
    type: SET_AFFILIATE_SETTING,
    data,
  }),
  getAffiliateSetting: () => ({
    type: GET_AFFILIATE_SETTING,
  }),
  postAffiliateSetting: (data, callback) => ({
    type: POST_AFFILIATE_SETTING,
    data,
    callback,
  }),
};
